import { UserPolicyServiceInterface } from '@src/server/services/types/user-policy.service.interface';
import { TermsConditionsApi, UserPolicyResponse } from 'cmp-client-api';

export class UserPolicyService implements UserPolicyServiceInterface {
  private readonly service: TermsConditionsApi;

  public constructor(service: TermsConditionsApi) {
    this.service = service;
  }

  public async getUserPolicy(): Promise<UserPolicyResponse> {
    return this.service.getUserPolicy().then(({ data }) => data);
  }

  public async createUserPolicy(xUserTimezone?: string): Promise<void> {
    return this.service.saveUserPolicy(xUserTimezone).then(({ data }) => data);
  }
}
